<router-outlet>
	<app-spinner></app-spinner>
</router-outlet>
